import React from "react";
import CrudPage from "./CrudPage";
export default function AdminSchemes() {
  return <CrudPage title="Skema Sertifikasi" endpoint="schemes" testPrefix="scheme" fields={[
    {key: "code", label: "Kode"},
    {key: "title", label: "Judul"},
    {key: "short_desc", label: "Deskripsi Singkat", type: "textarea"},
    {key: "description", label: "Deskripsi Lengkap", type: "textarea"},
    {key: "sk_number", label: "Nomor SK"},
    {key: "objective", label: "Tujuan", type: "textarea"},
    {key: "fee", label: "Biaya"},
  ]} />;
}
